import React from "react";
import Rating from "react-star-rating-lite/dist/rating";



export default class ProductReview extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rating: this.props.value,
            readOnly: false
        }

        this.onChange = this.onChange.bind(this);
    }


    onChange(rating) {
        this.setState({
            rating: rating
        });
        document.getElementById(this.props.fieldId).value = rating;
    };

    render()
    {
        return <div className="star-rating">
            <Rating onClick={this.onChange}
                    readonly={this.props.readOnly}
                    value={this.state.rating}
            />
        </div>;
    }

}
